/** @jsx jsx */
import {jsx} from 'theme-ui'
import {DetailedHTMLProps, ButtonHTMLAttributes} from 'react'
import {useTranslation} from 'react-i18next'

interface INextButton
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {}

const NextButton: React.FC<INextButton> = (props) => {
  const {t} = useTranslation()
  return (
    <button
      type="button"
      sx={{
        cursor: 'pointer',
        alignSelf: 'flex-start',
        borderRadius: 5,
        backgroundColor: 'primary',
        borderColor: 'primary',
        borderStyle: 'solid',
        color: '#fff',
        py: 16,
        px: 102,
        transition: 'color, background-color 0.3s linear',
        '&:hover': {
          backgroundColor: '#fff',
          color: 'primary',
        },
      }}
      {...props}
    >
      {t('Next')}
    </button>
  )
}

export default NextButton
